<template>
	<div id="appbox">
		<div class="top_heard">
				<div class="top_box" v-if="screenWidth>785">
					<div class="logo_box"  @click="gohome()">
						<img src="../../../static/img/logo.jpg" alt="" style="margin-top: 0px !important;"  height="" srcset="">
					</div>
					<div class="top_gatebox">
						<div class="manage_switch" v-if="screenWidth>785">
							<el-select v-model="manage_url" @change="manageurl"  size="small" class="Site_switch_type" placeholder="选择入口">
							  <el-option
							    v-for="item in manageoptions"
							    :key="item.value"
							    :label="item.label"
							    :value="item.value"
								>
							  </el-option>
							</el-select>
						</div>
						
					</div>
					<div class="top_search_box">
						<div class="top_search">
							<el-select v-model="top_search_url" size="small" class="top_search_type" placeholder="搜索类型">
							  <el-option
							    v-for="item in options"
							    :key="item.value"
							    :label="item.label"
							    :value="item.value">
							  </el-option>
							</el-select>
							<input type="text" v-model="stitle" autocomplete="off" placeholder="搜索关键词……" class="el-input__inner"  style="border: 0px;width: 200px;height: 30px;">
							<img class="top_search_icon" src="../../../static/img/顶部搜素图标.png" @click="_getNewslist()" alt="" srcset="">
						</div>
						  
						  
					</div>
					<div class="top_right">
						<div class="top_Mobiletype" @click="goregister()">
							账号注册/绑定
						</div>
						<div class=""  v-if="token" >
							欢迎访问!
						</div>
						<div class=""  v-if="token"  style="color: darkred;margin-left: 5px;" @click="logout()" >
							登出
						</div>
					</div>
				</div>
				
				<div class="top_tab_box">
					<van-nav-bar title="" style="color: #ffffff ;font-weight: 600;" @click-right="vannavshow=true" v-if="screenWidth<785" >
						<template #left>
							<div class="vannav_title" style="color: #217495;font-size: 16px;" >
								资讯资讯
							</div>
						</template>
						<template #title>
							<div class="vannav_title" style="width: 180px;padding: 20px;">
									<img src="../../../static/img/logo.jpg" alt="" style="margin-top: 0px !important;"  height="" srcset="">
							</div>
						</template>
					  <template #right>
						  <van-icon name="ellipsis"  size="20"    />
					  </template>
					</van-nav-bar>
					<van-popup v-model="vannavshow"  :style="{ height: '50%' }" position="top">
						<van-picker
						  title=""
						  show-toolbar
						  :columns="vannavlist"
						  confirm-button-text="进入"
						  @confirm="vanlinkgo"
						  @cancel="vannavmenushow"
						  @change="onChange"
						/>
					</van-popup>
					<div class="toptabnav" v-if="screenWidth>785">
							<el-menu
							  :default-active="activeIndex2"
							  class="el-menu-demo"
							  mode="horizontal"
							  @select="handleSelect"
							  router
							  background-color="#1b9d57"
							  text-color="#FFFFFF"
							  active-text-color="#FFFFFF">
								<el-menu-item index="/Home"  >首页</el-menu-item>
						<el-menu-item index="/Newslist" >研学资讯</el-menu-item>
						<el-menu-item index="/Campmap" >研学地图</el-menu-item>
						
						<el-submenu index="/institution">
						    <template slot="title">研学单位</template>
						    <el-menu-item index="/Camplist" >研学营地</el-menu-item>
						    <el-menu-item index="/Baselist" >研学基地</el-menu-item>
						    <el-menu-item index="/traveler" >研学机构</el-menu-item>
						  </el-submenu>
						
							<el-submenu index="/Courselist">
						    <template slot="title">研学产品</template>
						    <el-menu-item index="/Courselist" >研学课程</el-menu-item>
						<el-menu-item index="/Linelist" >研学线路</el-menu-item>
						  </el-submenu>
						  	<el-submenu index="/authLesson">
						    <template slot="title">认证申请</template>
						    <!-- <el-menu-item><a href="https://admin.henanyanxue.com/_uc/index" target="_blank" style="color: #ffffff;">学生证书申请</a></el-menu-item> -->
						    <el-menu-item index="/authLesson" >课程认证申请</el-menu-item>
						    <el-menu-item index="/authLesson" >基地认证申请</el-menu-item>
						    <el-menu-item index="/authLesson" >机构认证申请</el-menu-item>
						   
						  </el-submenu>
<!--						<el-menu-item index="/Activitylist">活动中心</el-menu-item>-->
						<el-submenu index="/Mentorlist">
						    <template slot="title">证书管理</template>
						    <el-menu-item><a href="https://admin.henanyanxue.com/_uc/index" target="_blank" style="color: #ffffff;">学生证书申请</a></el-menu-item>
						    <el-menu-item index="/Mentorlist" >导师证书查询</el-menu-item>
						   
						  </el-submenu>
						  
              			
						<el-menu-item index="/expertlist" >智库专家</el-menu-item>
             			<el-menu-item index="/OrgRegister" >入驻平台</el-menu-item>
							<!-- <el-menu-item index="/" >研学政策</el-menu-item> -->
						</el-menu>
					</div>
					<div class="top_banner">
						<el-carousel ref="carousel" :interval="4000"  :height="screenWidth>785?'480px':top_bannerWidth+'px'">
						  <el-carousel-item v-for="item in platelist" :key="item" >
						    <h3 class="medium" style="width: 100%;height: 100%;"><img :src="item.thumb"  style="width: 100%;height: 100%;" alt="" srcset="" @click="gomodules(item.link)"></h3>
						  </el-carousel-item>
						</el-carousel>
					</div>
		<!-- 			<div class="top_plate">
						<div class="plate_item" v-for="(plate, index) in platelist" :key="plate" @mouseover="showstep(index)" @click="goplate(plate.id)" >
							<div class="plate_icon">
								<img :src="plate.icon" alt="" srcset="">
							</div>
							<div class="plate_title">
								{{plate.title}}
							</div>
						</div>
					</div> -->
				</div>
			</div>
		<div class="main_box" :style="screenWidth>785?'':'width:100%;'">
			<div class="newslist_box">
				<div class="newslist"  :style="screenWidth>575?'':'width:100%;'">
						<el-tabs  @tab-click="handleClick"  :style="screenWidth>575?'':'width:100%;'" v-model="category_id" >
							<el-tab-pane v-for="(items, index) in types"  :key="items"  :name="items.id+''"   :label="items.title">
								<div class="newsitem" :style="screenWidth>785?'':'width:calc(100% - 20px);'" v-for="item in newslist" :key="item"  @click="detail(item.id,item.link)" >
									<div class="newsimg" :style="screenWidth>785?'':'aspect-ratio: 600/338;height:auto;'" >
										<img :src="item.icon" :style="screenWidth>785?'':'aspect-ratio: 600/338;height:auto;'" alt="" srcset="">
									</div>
									<div class="newsmsg" :style="screenWidth>785?'':'aspect-ratio: 388/170;height:auto;padding:0px;'" >
										<div class="newstitle" :style="screenWidth>785?'-webkit-box-orient:vertical;':'-webkit-box-orient:vertical;font-size:16px;'">
											{{item.title}}
										</div>
										<div class="author">
											  <el-tag
											    type="warning"
											    effect="plain"
												:size="screenWidth>785?'medium':'mini' ">
											   {{item.author||'未知'}}
											  </el-tag>
										</div>
										<div class="news_bottom">
											<div class="newstime">
												{{item.update_time}}
											</div>
											<div class="pageview">
												<i class="el-icon-view"></i>
												{{item.uv}}
											</div>
										</div>
									</div>
								</div>
								<div class="pages_total" :style="screenWidth>785?'':'padding:15px;'" >
									<el-pagination
									  background
									  :page-size="10"
									  :hide-on-single-page="true"
									  :small="screenWidth<785"
									  :pager-count="screenWidth>785?7:5"
									  @current-change="pagechange"
									  layout="total, prev, pager, next"
									  :total="total">
									</el-pagination>
								</div>
							</el-tab-pane>
							
					
						</el-tabs>
				</div>
				<div class="quicknewslist" v-if="screenWidth>785">
					<div class="quick_title">
						最新资讯
					</div>
					<div class="quicknews"   >
						<div class="quick_items"   v-for="(item, index) in quicklist" :key="item" @click="detail(item.id,item.link)" @mouseenter="onitemopen(index)" >
							<i class="el-icon-question" v-if="index!=newsiconon" style="color: #ddd;"></i>
							<i class="el-icon-warning-outline" v-if="index==newsiconon" style="color: #1b9d57;font-size: 22px;"></i>
							<img :src="item.icon" v-if="index==newsiconon" alt="" srcset="">
							<div :class="index==newsiconon?'quick_text2':'quick_text'"   :style="index==newsiconon?'-webkit-box-orient:vertical;':''" >
								{{item.title}}
							</div>
						</div>
					</div>
				</div>
			</div>
			
			
		</div>
		
		<div :class="tops?'navbar':'navbar-top'" v-if="screenWidth>785">
		     <el-tooltip class="item" effect="dark" content="返回首页" placement="left">
		             <a style="display: flex;flex-direction: column;justify-content: center; align-items: center;"  @click="gohome()"><i class="el-icon-s-home"></i>
								<div style="font-size: 14px;">首页</div></a>
		     </el-tooltip>
		     <div  class="qrShow3 right2"   v-if="showofficialQR">
					<img src="../../../static/img/gzhsuncode.jpg" style="width: 100px; height: 100px;border-radius: 8px;" />
				</div>
				<a style="display: flex;flex-direction: column;justify-content: center; align-items: center;" @mouseover="showofficialQRCode" @mouseleave="hideofficialQRCode"><i class="el-icon-s-help"></i>  
							
				    <div style="font-size: 14px;">公众号</div></a>
				<div  class="qrShow2 right2" v-if="showserviceQR">
					<img src="../../../static/img/客服码.png" style="width: 100px; height: 100px;border-radius: 8px;" />
				</div>
				<a style="display: flex;flex-direction: column;justify-content: center; align-items: center;" @mouseover="showserviceQRCode" @mouseleave="hideserviceQRCode"><i class="el-icon-service"></i>  
							
				    <div style="font-size: 14px;">客服</div></a>
		     <div  class="qrShow right" v-if="showQR">
							<img src="../../../static/img/suncode.jpg" style="width: 100px; height: 100px;border-radius: 8px;" />
		     </div>
		       <!-- <a style="display: flex;flex-direction: column;justify-content: center; align-items: center;" @mouseover="showQRCode" @mouseleave="hideQRCode"><i class="el-icon-mobile-phone"></i> 
					
		         <div style="font-size: 14px;">手机端</div></a> -->
		     <el-tooltip class="item" effect="dark" content="返回顶部" placement="left" v-if="tops">
		         <a @click="gotop"><i class="el-icon-caret-top"></i>
		         <br>
		         <span>顶部</span></a>
		     </el-tooltip>
		 </div>
		<!-- footer -->
		<div class="pagesbottom_box"  :style="screenWidth>785?'':'width:100%;'" >
			<div class="subtexts" v-if="screenWidth>785" >
				<div v-for="(item, key) in bottomnav" :key="key" @click="gobottomnav(item.type,item.linkurl)">{{item.title}}</div>
			</div>
			<div class="subnavbox" v-if="screenWidth<785" >
				<div class="subtext_title">
					关于研学平台
				</div>
				<div class="subtexts" :style="screenWidth>785?'':'width:calc(100% - 40px);flex-wrap:wrap;padding:20px;margin-top: 0px;'" >
					<div v-for="(item, key) in bottomnav" :key="key" :style="screenWidth>785?'':'width:25%;text-align: left;margin-bottom:15px'"  @click="gobottomnav(item.type,item.linkurl)">{{item.title}}</div>
				</div>
			</div>
		<div class="footer_box">
			<div class="row"  :style="screenWidth>785?'padding-bottom:0px':'width:calc(100% - 20px);padding:0px 10px;padding-bottom:0px'">
				
				<div class="copy-left" :style="screenWidth>785?'':'width:40%;'">
				</div>
				
				<div class="bottom_right" :style="screenWidth>785?'':'margin-left:10px;'">
					<div class="bottom_msg">
						指导单位：河南省教育厅   主办单位：河南省研学旅行教育协会
					</div>
				</div>
				
			</div>
			<div class="row"  :style="screenWidth>785?'':'width:calc(100% - 20px);padding:0px 10px;'">
				
				<div class="copy-left" :style="screenWidth>785?'':'width:40%;'">
				</div>
				
				<div class="bottom_right" :style="screenWidth>785?'':'margin-left:10px;'">
					<div class="bottom_msg">
						{{pcsetdata.foot}}
					</div>
					<div class="bottom_msg">
						<a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener">{{' '+pcsetdata.icp}}</a>
					</div>
					<div class="bottom_msg">
						课程适用人群:学生群体
					</div>
				</div>
				
			</div>
		</div>
		</div>
	</div>
	
	
</template>

<script >
	import { getBanner, getWxLogin, getAclist, getNewslist, getCategory, getPc, getPlate,getbottomnav } from '@/request/api'
	
	export default {
	  name: "newslist",
	    // components: {
	    //   navTab
	    // },
	  data(){
		  return {
			  bottomnav:[],
			  top_search_url:'/Newslist',
			  manage_url:'',
			  manageoptions:[
			  	{
			  	  value: 'http://qianjin.wanjiaxiao.cn/',
			  	  label: '研学报备'
			  	}, {
			  	  value: 'https://admin.henanyanxue.com/',
			  	  label: '管理入口'
			  	},
			  
			  ],
			  stitle:'',
			  options: [{
			            value: '/Newslist',
			            label: '资讯搜索'
			          }],
				platelist:[],
				activeIndex2: '/Newslist',
				phoneboxshow:false,
				userInfo: {
				  username: "",
				  education_name: "",
				  role_level: ""
				},
				modules:'',
				logintype:true,
				banner:[
				],
				types:[],
				newslist:[],
				quicklist:[],
				aclist:[],
				newsiconon:'',
				category_id:'',
				total:0,
				page_index:1,
				pcsetdata:{},
				showQR:false,
			 showserviceQR:false,
			  showofficialQR:false,
				tops:false,
				heights:window.innerHeight,
				scrolltop:'',
				//屏幕宽高
				// 屏幕宽度
				screenWidth: window.innerWidth,
				top_bannerWidth:Math.round(window.innerWidth/3.42),
				// 屏幕高度
				screenHeight: window.innerHeight,
				//手机端导航栏
				vannavshow:false,
				vannavlist:[
					{
						link:'/Home',
						text:'研学首页'
					},
					{
						link:'/Camplist',
						text:'营地列表'
					},
					{
						link:'/Baselist',
						text:'基地列表'
					},
					{
						link:'/Courselist',
						text:'研学课程'
					},
					{
						link:'/Activitylist',
						text:'研学活动'
					},
					{
						link:'/Linelist',
						text:'研学线路'
					},
					{
						link:'/traveler',
						text:'研学机构'
					},
					{
						link:'/mentorlist',
						text:'研学指导师'
					},
					{
						link:'/expertlist',
						text:'专家团队'
					},
          {
            link: '/OrgRegister',
            text: '入驻平台'
          },
				],
		      }
	  },
	  beforeCreate(){
	  	   const loading = this.$loading({
	  	            lock: true,
	  	            text: '页面载入……',
	  	            // spinner: 'el-icon-loading',
	  	            background: '#ffffff'
	  	          });
	  },
	  created(){
			
		    this.getpcset()
	  },
	  mounted() {
		  // 监听屏幕宽度和高度变化
		  // this.top_bannerWidth=window.innerWidth/3.42
		    window.addEventListener('resize', this.handleResize, true)
		  const { stitle } = this.$route.query;
		  const {id}=this.$route.query
		  this.category_id=id || '0'
		  console.log("555555",this.category_id);
		  this.stitle = stitle||''
		  var token = localStorage.getItem('token')||''
		  this.token=token
		  this.getPlate()
		  this.gettypes()
		  this.getbottomnav()
		// this._getNewslist()
		this.getQuicklist()
	
	  window.addEventListener('scroll', this.scrollToTop)
	  		
	  },
	   destroyed () {
	          window.removeEventListener('scroll', this.scrollToTop)
	    },
		// 销毁监听
		beforeDestroy() {
		  window.removeEventListener('resize', this.handleResize);
		},
	  methods: {
		  manageurl(e){
		  		  console.log('Site',e)
		  		  if(e!='/'){
		  			   window.open(e) 
		  		  }
		  		//this.manage_url='/'
		  		  // window.location.href = e;
		  		  
		  },
		  vanlinkgo(e){
		  		  console.log(e)
		  		  this.$router.push({
		  		    path: e.link,
		  		    name: e.link,
		  		    query: {
		  		    }
		  		  }); 
		  },
		  vannavmenushow(){
		  		this.vannavshow=false  
		  },
		  handleResize() {
		  		   this.top_bannerWidth = 0;
		    this.screenWidth = window.innerWidth;
		  		this.top_bannerWidth=window.innerWidth/3.42
		  		console.log('screenWidth',this.screenWidth,this.top_bannerWidth)
		    this.screenHeight = window.innerHeight;
		  },
		  getbottomnav(){
		  		  var data={
		  			  page_index:1,
		  			  page_size:15
		  		  }
		  		getbottomnav(data).then(res=>{
		  			this.bottomnav=res.data.data.list
		  		})  
		  },
		  gobottomnav(type,link){
		  		  if(type==1){
		  			  this.$router.push({
		  			  	path:link
		  			  });
		  		  }else if(type==2){
			  window.location.href = link;
		  }
		  },
		  logout(){
		  			  var that=this
		  			  this.$confirm('是否确认退出登录?', '提示', {
		  			  					confirmButtonText: '确定',
		  			  					cancelButtonText: '取消',
		  			  					type: 'warning'
		  			  }).then(() => {
		  						this.$alert("已退出登录", '', {
		  							confirmButtonText: '确认',
		  							callback: action => {
		  								localStorage.setItem('token', '')
		  								localStorage.setItem('refreshToken', '')
		  								 that.$router.go(0)
		  							}
		  						  });
		  			  }).catch(() => {
		  			  		 
		  			  });
		  },
		  showofficialQRCode(){
		  		 this.showofficialQR=true
		  },
		  hideofficialQRCode(){//隐藏二维码
		      this.showofficialQR = false
		  },
		  showserviceQRCode(){
		  			  this.showserviceQR=true
		  },
		  hideserviceQRCode(){//隐藏二维码
		      this.showserviceQR = false
		  },
		  showQRCode(){//显示二维码
		          this.showQR = true
		      },
		      hideQRCode(){//隐藏二维码
		          this.showQR = false
		      },
		      scrollToTop () {
		          let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
		          this.scrolltop = scrollTop
		          if (parseInt(this.scrolltop) > (parseInt(this.heights) / 3)) {
		              this.tops = true
		          } else {
		              this.tops = false
		          }
		      },
		      gotop () {
		          let timer = setInterval(() => {
		              document.documentElement.scrollTop = document.body.scrollTop = this.scrolltop - 90
		              if (this.scrolltop === 0) {
		                  clearInterval(timer)
		              }
		          }, 15)
		      },
		  showstep(ind) {
		       this.$refs.carousel.setActiveItem(ind)
		     },
		  goplate(id){
			   this.modules=id
			   this._getNewslist()
			   this.getQuicklist()
		  },
		  getPlate(){
		  		var data={
		  			
		  		}  
		  		getPlate(data).then(res=>{
		  			this.platelist=res.data.data
		  		})
		  },
		  showphonebox(){
		  		this.phoneboxshow=true  
		  },
		  closephonebox(){
		  		this.phoneboxshow=false  
		  },
		  goregister(e){
			  this.$router.push({
				path: "/register",
				name: "/register",
					  query: {
					  }
			  });
		  },
		  gohome(e) {
		    this.$router.push({
		      path: "/Home",
		      name: "/Home",
		  			  query: {
		  			  }
		    });
		  },
	  		  getpcset(){
	  		  		getPc().then(res=>{
	  		  			this.pcsetdata=res.data.data
						
	  		  		})  
	  		  },
		  pagechange(val){
			  this.page_index=val
			   this._getNewslist()
		  },
		  handleClick(e){
				console.log(e.name,this.category_id)
				this.page_index=1
				 this._getNewslist()
		  },
		  onitemopen(index){
			  this.newsiconon=index
		  },
		  gettypes(){
			  var data={}
			  getCategory(data).then(res=>{
			    			  console.log(res.data)
							  var types=[
								  {
									  id:'0',
									  icon:'',
									  title:'全部资讯'
								  }
							  ]
							  for(var item of res.data.data){
								  types.push(item)
							  }
			    			  this.types=types
							//   this.category_id='0'
							  console.log(this.category_id)
							  this._getNewslist()
							  
							  
			    }).catch(error => {
			    			  console.error(error);
			    			});
		  },
		getQuicklist(){
			var data={
				  page_index:1,
				  page_size:10,
				  	modules:this.modules,
			  }
			getNewslist(data).then(res=>{
			  			  console.log(res.data)
						  this.quicklist=res.data.data.list
						  
			  }).catch(error => {
			  			  console.error(error);
			  			});
		},
		  _getNewslist(){
			  var data={
				  page_index:this.page_index,
				  page_size:10,
				  category_id:this.category_id,
				  	modules:this.modules,
					title:this.stitle,
			  }
			  const loading = this.$loading({
			           lock: true,
			           text: '页面载入……',
			           // spinner: 'el-icon-loading',
			           background: '#ffffff'
			         });
			getNewslist(data).then(res=>{
			  			  console.log(res.data)
			  			  this.newslist=res.data.data.list
						  this.total=res.data.data.total
						  loading.close();
			  }).catch(error => {
			  			  console.error(error);
			  			});
		  },
		
		   handleSelect(key, keyPath) {
		          console.log(key, keyPath);
		        },
	    /*
	     * 查看详情
	     * */
	    detail(e,link) {
			console.log("1112",link)
			// return
			if(link){
				window.location.href=link
			}else{
				let routedata = this.$router.resolve({path: "/NewsDetails",query:{id:e}});
				window.open(routedata.href,'_blank');
			}
		
	      // this.$router.push({
	      //   path: "/NewsDetails",
	      //   name: "NewsDetails",
	      //   query: {
	      //     id: e
	      //   }
	      // });
	    },
		gomodules(e){
			if(e){
				window.location.href = e;
			}
		},
	  }
	};
		
</script>
<style scoped>
	.pageview{
		display: flex;
		align-items: center;
	}
	::v-deep .el-tabs__item.is-active{
		color: #1b9d57;
	}
	
</style>
<style >
	.el-tabs__nav-scroll>.el-tabs__nav>.el-tabs__active-bar>.el-tabs__item.is-active{
		color: #1b9d57 !important;
	}
	.el-tabs__nav-scroll>.el-tabs__nav>.el-tabs__active-bar>.el-tabs__item:hover{
		color: #1b9d57 !important;
	}
	.main_box{
		width: 1100px;
		min-height: 600px;
		margin: 0 auto;
	}
	.newslist_box{
		width: 100%;
		display: flex;
		justify-content: space-between;
		align-items: flex-start;
	}
	.newslist{
		width: 790px;
		background: #fff;
		margin: 20px;
		margin-left: 0px;
	}
	.newsitem{
		width:720px ;
		margin: 0px  10px;
		padding: 20px 0px;
		border-bottom: 1px dashed #dadada;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.newsimg{
		width: 280px;
		height: 180px;
		margin-right:20px ;
	}
	.newsimg img{
		width: 100%;
		height: 100%;
	}
	.newsmsg{
		width:388px;
		height:140px ;
		padding: 20px 0px;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
	}
	.newstitle{
		font-weight: 400;
		font-size: 24px;
		color: #333;
		/* margin-bottom: 15px; */
		text-align: left;
		/* height: 50px; */
		/* line-height: 50px; */
		text-overflow: ellipsis;
		white-space: normal;
		overflow: hidden;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
	}
	.newstitle:hover{
		color: #1b9d57;
	}
	.author{
		text-align: left;
	}
	
	.el-tabs--border-card>.el-tabs__header .el-tabs__item.is-active{
		color: #1b9d57;
	}
	.el-tabs--border-card>.el-tabs__header .el-tabs__item:not(.is-disabled):hover{
		color: #1b9d57;
	}
	

	.el-tabs__item{
		font-size: 18px;
		height: 60px;
		line-height: 60px;
		/* padding:30px ; */
	}
	.el-tabs--border-card .el-tabs__header{
		background-color: #ffffff;
	}
	.news_bottom{
		    font-size: 14px;
		    color: #999;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}
	.pages_total{
		padding: 20px;
		padding-bottom: 0px;
		
	}
	.el-pagination.is-background .el-pager li:not(.disabled).active{
		background-color: #1b9d57;
	}
	
	/* 快速资讯内容 */
	.quicknewslist{
		width: 395px;
		background-color: #ffffff;
		margin-top: 20px;
		border: 1px solid #DCDFE6;
		box-shadow: 0 2px 4px 0 rgba(0,0,0,.12), 0 0 6px 0 rgba(0,0,0,.04);
	}
	.quick_title{
		    padding: 20px  0px;
		    background: #fff;
		    border-bottom: 2px solid #f8f8f8;
			font-size: 20px;
			color: #333;
			font-weight: 400;
	}
	.quicknews{
		padding: 20px;
	}
	.quick_items{
		display: flex;
		align-items: center;
		justify-content: flex-start;
		margin: 20px 0px;
		
	}
	.quick_items i{
		margin-right: 10px;
	}
	.quick_items img{
		width: 120px;
		height: 77px;
		/* margin-left: 10px; */
		margin-right: 10px;
		background-color: #333;
	}
	.quick_text{
		    /* width: 100%; */
		color: #333;
		    font-size: 16px;
		    font-weight: 400;
		    line-height: 2;
		    overflow: hidden;
		    text-overflow: ellipsis;
		    white-space: nowrap;
			text-align: left;
	}
	.quick_text2{
		/* color: #333; */
		width: 180px;
		font-size: 16px;
		font-weight: 400;
		color: #1b9d57;
		white-space: normal;
		/* line-height: 2; */
/* 		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap; */
		text-align: left;
		text-overflow: ellipsis;
		white-space: normal;
		display: -webkit-box;
		-webkit-line-clamp:2;
		-webkit-box-orient:vertical;
		overflow: hidden;

	}
	@media only screen and (max-width: 768px){ /* 在小于等于768px的设备上执行该CSS代码 */
	
		.el-tabs__item{
			font-size: 16px;
		}
	
	}
</style>